export default class MetadataBase {
    deduplicate(arrayToDeduplicate: Array<any>) {
        var store = this;
        let deduplicatedArray: Array<any> = arrayToDeduplicate.filter(function(item, pos) {
            return arrayToDeduplicate.indexOf(item) == pos;
        })

        return deduplicatedArray;
    }
}